import $ from "jquery";
import jQuery from "jquery";

// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;

// // set CSRF token for every AJAX request using jquery.cookie
require('jquery.cookie');

let Swiper = require('./swiper');
require('jquery.mmenu/dist/jquery.mmenu.all.css');
require('jquery.mmenu/dist/jquery.mmenu.all');
$.ajaxSetup({headers: {'X-XSRF-TOKEN': $.cookie('XSRF-TOKEN')}});

$(function () {
    let $time = 1000;
    let div = $('.detail_right_side');

    if (div.length) {
        let blocks = $('.detail_right_side_blocks');
        let $height = $('.page_header').height() / 2;

        let divForm = div.find('.form');
        div.animate({top: -$height}, $time);
        divForm.animate({opacity: 1}, $time);

        setTimeout(function () {
            blocks.animate({opacity: 1}, $time / 2);
        }, $time);

        let closestContainer = div.closest('.container');

        $(window).on('load resize', function () {

            let closestContainerHeight = closestContainer.height();
            let divHeight = div.height();
            let divRelativeHeight = (divHeight - $height) + 50;

            if ($(window).width() < 1200) {
                closestContainer.css('height', 'auto');
                return false;
            }

            if (divRelativeHeight >= closestContainerHeight) {
                closestContainer.css('height', divRelativeHeight);
            } else {
                closestContainer.css('height', 'auto');
            }
        });
    }


    $('.swiper-container-holder').each(function () {
        let $this = $(this);
        let swiper = new Swiper($this.find('.swiper-container'), {
            spaceBetween: 30,
            loop: true,
            navigation: {
                nextEl: $this.find('.swiper-button-next'),
                prevEl: $this.find('.swiper-button-prev'),
            },
            slidesPerView: 2,
            breakpoints: {
                // when window width is <= 320px
                768: {
                    slidesPerView: 1,
                }
            }
        });

    });

});

$(function () {

    $('ul.tabs li').click(function () {
        var tab_id = $(this).attr('data-tab');
        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $("#tab-" + tab_id).addClass('current');
    })

    var $hamburger = $(".hamburger");
    $hamburger.on("click", function (e) {
        $hamburger.toggleClass("is-active");
    });


    let $mmenu = $("#menu").mmenu({
        "extensions": [
            "position-right",
            "pagedim-black"
        ]
    });

    var $mmenuButton = $('#mmenu-button');

    var mmenuAPI = $mmenu.data("mmenu");

    mmenuAPI.bind("open:finish", function () {
        $mmenuButton.addClass("is-active");
    });

    mmenuAPI.bind("close:start", function () {
        $mmenuButton.removeClass("is-active");
    });


    $('form').each(function () {
        let $form = $(this);
        let $formButton = $form.find('button');
        let $recaptcha = $form.find('.g-recaptcha');

        let resetRecaptcha = function () {
            let widgetId = $recaptcha.data('widget-id');
            if (widgetId !== undefined && window.grecaptcha) {
                grecaptcha.reset(widgetId);
            }
        };

        $form.on('submit', function () {
            if ($recaptcha.length && !$form.find('.g-recaptcha-response').val()) {
                let widgetId = $recaptcha.data('widget-id');
                if (widgetId !== undefined && window.grecaptcha) {
                    grecaptcha.execute(widgetId);
                }
                return false;
            }

            let $text = $formButton.text();
            $formButton.html('<i class="fa fa-spin fa-spinner"></i>');
            $formButton.prop('disabled', true);
            $form.find('.is-invalid').removeClass('is-invalid');

            $.post($form.attr('action'), $form.serializeArray(), function (response) {
                if (response.success) {
                    if ($form.data('ga') && window.gtag !== undefined) {
                        gtag('event', 'macro-conversie', {
                            'event_category': $form.data('ga'),
                            'event_label': $form.data('url')
                        });
                    }

                    if (response.redirect) {
                        window.location.href = response.redirect;
                    } else {
                        $formButton.html('Verstuurd <i class="fa fa-check"></i>');
                        $formButton.prop('disabled', true);
                        $form.find('input').val("");
                        $form.find('textarea').val("");
                        resetRecaptcha();

                        setTimeout(function () {
                            $formButton.html($text);
                            $formButton.prop('disabled', false);
                        }, 5000);
                    }
                } else {
                    $formButton.html($text);
                    $formButton.prop('disabled', false);
                    resetRecaptcha();
                }
            }).fail(function (r) {
                $formButton.html('<i class="fa fa-times"></i>');
                resetRecaptcha();
                if (r.responseJSON.errors !== undefined) {
                    for (let i in r.responseJSON.errors) {
                        $form.find('[name=' + i + ']').addClass('is-invalid');
                    }
                }
                setTimeout(function () {
                    $formButton.html($text);
                    $formButton.prop('disabled', false);
                }, 5000);
            });
            return false;
        });
    });


    $('.faq-items').each(function () {
        $(this).on('click', function () {
            let $this = $(this);
            $this.find('.faq-answere').slideToggle();
        })
    })


    let latlng = $('#map').data('gps');
    if (latlng) {
        var map = new google.maps.Map(document.getElementById('map'), {
            zoom: 2,
            disableDefaultUI: true,

        });
        var bounds = new google.maps.LatLngBounds();

        for (let $i = 0; $i < latlng.length; $i++) {
            var marker = new google.maps.Marker({
                position: {
                    lat: +latlng[$i][0],
                    lng: +latlng[$i][1]
                },
                map: map,
            });
            bounds.extend(marker.position);
        }
        map.fitBounds(bounds);
        setTimeout(function () {
            var zoom = map.getZoom();
            map.setZoom(13);
        }, 200)
    }
});

$(document).ready(function () {
    // Hide form when > 1 date
    if ($('#signup_info').children().length > 2) {
        $('.hide-before-date-selected').css("visibility", "hidden");
    }
    // Select existing date
    else {
        $('#signup_info option').each(function () {
            if (!$(this).prop("disabled")) {
                $(this).attr("selected", "selected");
            }
        });
    }

    // Show form when date selected
    $('select').on('change', function () {
        if (!$(this).prop("disabled")) {
            if ($(this).val()) {
                $('.hide-before-date-selected').css({opacity: 0.0, visibility: "visible"}).animate({opacity: 1}, 1200);
            }
        }
    });
});

$(document).ready(function () {
    setTimeout(function () {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
        head.appendChild(script);
    }, 3000);

    window.onloadCallback = function () {
        $(".g-recaptcha").each(function () {
            var $widget = $(this);
            var $form = $widget.closest('form');

            try {
                var widgetId = grecaptcha.render($widget.attr("id"), {
                    "sitekey": window.sitedata.recaptchakey,
                    "size": "invisible",
                    "callback": function (token) {
                        $form.find(".g-recaptcha-response").val(token);
                        $form.trigger('submit');
                    }
                });
                $widget.data('widget-id', widgetId);
            } catch (error) {
            }
        });
    };
});
